import { ILinkTranslation } from '../interfaces/Translations';

interface ITranslationObject {
  [key: string]: string | undefined;
}

export interface ITextElementProps {
  text: string;
  placeholder: string;
}

export interface ILinkElementProps {
  link: ILinkTranslation;
  testId: string;
  placeholder: string;
}

export type TGetLinkElement = (
  key: string | number,
  linkElementProps: ILinkElementProps
) => JSX.Element;

export default class TranslationUtils {
  static isTranslationItemEmpty = (translationItem: string): boolean => {
    if (translationItem && typeof translationItem === 'string') {
      return translationItem.substr(0, 6) === '::elc_' || /^~\S+~$/.test(translationItem);
    }
    return true;
  };

  static isTranslationItemValid = (translationItem: string): boolean => typeof translationItem === 'string';

  // gracefully handles invalid translation type
  static replace = (
    value: string,
    searchValue: RegExp | string,
    replaceValue: string,
  ): string => (TranslationUtils.isTranslationItemValid(value)
    ? value.replace(searchValue, replaceValue) : '');

  static replacePlaceholdersWithValue(
    translationsObject: ITranslationObject,
    value: string | undefined,
  ): ITranslationObject {
    return Object.keys(translationsObject).reduce((acc: ITranslationObject, key) => {
      acc[key] = TranslationUtils.isTranslationItemEmpty(translationsObject[key])
        ? value : translationsObject[key];
      return acc;
    }, {});
  }

  static getPlaceHolderElement(
    key: string,
    links: ILinkElementProps[],
    texts: ITextElementProps[],
    getLinkElement: TGetLinkElement,
  ): JSX.Element | string {
    const linkElementProps = links.find(link => link.placeholder.includes(key));
    if (linkElementProps) {
      return getLinkElement(key, linkElementProps);
    }
    const textElementProps = texts.find(text => text.placeholder.includes(key));
    if (textElementProps) {
      return textElementProps.text || textElementProps.placeholder;
    } else {
      return `::${key}::`;
    }
  }
}
